import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import auth from './authSlice'
import language from './languageSlice'
import common from './commonSlice'
import order from './orderSlice'
import address from './addressSlice'
import country from './countrySlice'
import cacheSlice from './cacheSlice'
import notifySetting from './notifySettingSlice'
import task from './taskSlice'
import stock from './stockSlice'
import message from './messageSlice'
import express from './expressSlice'
import dictionary from './dictionarySlice'
import goods from './goodsSlice'
import subscribeSlice from './subscribeSlice'
import refund from './refundSlice'
import configSlice from './configSlice'
import captchaSlice from './captchaSlice'

const history = createBrowserHistory()
const reducers = {
  auth,
  language,
  common,
  order,
  address,
  country,
  cacheSlice,
  notifySetting,
  task,
  stock,
  message,
  express,
  dictionary,
  goods,
  subscribeSlice,
  refund,
  configSlice,
  captchaSlice,
}

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
